module.exports = __webpack_public_path__ + "static/img/Ten of Wands.c11ec10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Ten of Wands.jpg
// module id = 1307
// module chunks = 0